import { useAtom } from '@reatom/npm-react'
import { AnimatePresence } from 'motion/react'

import {
  storageSessionAtom,
  createPasswordControllerAtom,
  enterPasswordControllerAtom,
} from '../atoms'

import { CreateLocalPasswordDialog } from './initialize-secure-storage-dialog'
import { LocalPasswordDialog } from './local-password-dialog'

export const LocalPasswordDialogController = () => {
  const [enterPasswordController] = useAtom(enterPasswordControllerAtom)
  const [createPasswordController] = useAtom(createPasswordControllerAtom)

  const [session] = useAtom(storageSessionAtom)

  if (!session) {
    return
  }

  return (
    <>
      <AnimatePresence>
        {enterPasswordController ? (
          <LocalPasswordDialog
            open={true}
            controller={enterPasswordController}
          />
        ) : undefined}
      </AnimatePresence>
      <AnimatePresence>
        {createPasswordController ? (
          <CreateLocalPasswordDialog
            open={true}
            controller={createPasswordController}
          />
        ) : undefined}
      </AnimatePresence>
    </>
  )
}
